import { useCallback, useEffect, useMemo, useState } from "react";
import ModalList, {
  ModalListItem,
} from "../../../../components/misc/ModalList/ModalList";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { clearScheduleWorkingPoints } from "../../../../redux/reducer/expedition.reducer";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import { setSelectedActiveTransport } from "../../../../redux/reducer/raports.reducer";
import { postEndActiveTransport } from "../../../../redux/api/transport.api";

export interface ReasonListDataInterface {
  id: number;
  label: string;
}

const endTransportReasonsListData: ReasonListDataInterface[] = [
  { id: 1, label: "Utilizatorul a uitat sa inchida cursa" },
  { id: 2, label: "Motiv1" },
  { id: 3, label: "Motiv2" },
  { id: 4, label: "Motiv3" },
  { id: 5, label: "Motiv4" },
];

function EndActiveTransportModal() {
  const dispatch = useAppDispatch();

  const {
    raports: { selectedActiveTransport },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [selectedReason, setSelectedReason] =
    useState<ReasonListDataInterface | null>(null);

  const [isLoading, setIsLoading] = useState(false);

  const initialEndTransportReasonsList: ModalListItem[] = useMemo(
    () =>
      endTransportReasonsListData.map((item) => {
        const { id, label } = item;
        return {
          ...item,
          label: `${label}`, // required
          id: id, // required
          backgroundColor: id === selectedReason?.id ? "warning" : "info",
        };
      }),
    [selectedReason?.id],
  );

  useEffect(() => {
    return () => {
      dispatch(clearScheduleWorkingPoints());
    };
  }, [dispatch]);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!selectedActiveTransport || !selectedReason) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        postEndActiveTransport({
          page: 1,
          perPage: 50,
          idActiveTransport: selectedActiveTransport.id_transport,
          idSelectedReason: selectedReason.id,
        }),
      );

      if (
        checkEndpointStatus(resultAction, postEndActiveTransport) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, postEndActiveTransport) ===
        endpointStatus.fulfilled
      ) {
        handleClose && handleClose();
      }
    },
    [selectedActiveTransport, selectedReason, dispatch],
  );

  const onClose = useCallback(() => {
    dispatch(setSelectedActiveTransport(null));
    setSelectedReason(null);
  }, [dispatch]);

  return (
    <ModalList
      dynamicModalOpen={!!selectedActiveTransport}
      onClose={onClose}
      label="Motiv incheiere transport"
      withSearch={false}
      searchPlaceholder={"Cauta un motiv pentru incheierea transportului"}
      modalTitle={"Motive pentru incheierea transportului"}
      items={initialEndTransportReasonsList}
      selectedItem={{
        id: selectedReason?.id || "",
        label: selectedReason?.label || "",
      }}
      setSelectedItem={setSelectedReason}
      withCloseAfterSelect={false}
      CustomModalFooter={({ handleClose }: any) => (
        <div className="flex justify-between gap-4">
          <CustomButton onClick={handleClose}>Inapoi</CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            onClick={() => {
              handleOnSubmit({ handleClose });
            }}>
            Salveaza
          </CustomButton>
        </div>
      )}
      CustomOpenModalComponent={() => <></>}
    />
  );
}

export default EndActiveTransportModal;
